<template>
  <div
    v-if="visible"
    class="nup-sticky"
  >
    <div
      v-if="isPC"
      class="nup-sticky__panel"
      :style="{ backgroundImage: 'url(' + pcBar + ')' }"
    >
      <button
        type="button"
        class="nup-sticky__btn"
        :disabled="disabled"
        :style="{ backgroundImage: 'url(' + btnBg + ')' }"
        @click="$emit('click')"
      >
        {{ text }}
      </button>
    </div>
    <button
      v-else
      type="button"
      class="nup-sticky__btn"
      :disabled="disabled"
      :style="{ backgroundImage: 'url(' + btnBg + ')' }"
      @click="$emit('click')"
    >
      {{ text }}
    </button>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { useNupLang } from '../composables/use-nup-lang';
import { usePageTypeFlag } from '../composables/use-page-type';
import { findPcStickyBar } from '../constants/rewards';
import btnBg from '../assets/rewards/btn-bg.png';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: '立即報名'
  },
  disabled: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    isPC
  } = usePageTypeFlag();
  const {
    isEn
  } = useNupLang();
  const pcBar = computed(() => findPcStickyBar(isEn.value));
  return {
    btnBg,
    isPC,
    pcBar
  };
};
export default __sfc_main;
</script>

<style scoped>
.nup-sticky {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 24px 32px calc(24px + env(safe-area-inset-bottom));
  background: rgba(30, 30, 30, 0.85);
}

.nup-sticky__btn {
  display: block;
  width: 690px;
  height: 100px;
  margin: 0 auto;
  padding: 0;
  border: none;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  line-height: 100px;
  text-align: center;
  cursor: pointer;
}

.nup-sticky__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.nup-page.is-pc .nup-sticky {
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  background: transparent;
  box-shadow: none;
  pointer-events: none;
}

.nup-page.is-pc .nup-sticky__panel {
  position: relative;
  width: 913px;
  height: 117px;
  pointer-events: auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.nup-page.is-pc .nup-sticky__btn {
  position: absolute;
  right: 24px;
  bottom: 23px;
  width: 260px;
  height: 54px;
  margin: 0;
  overflow: hidden;
  border-radius: 27px;
  font-size: 20px;
  line-height: 54px;
}
</style>
